// src/components/NotFound.js
import React from "react";
import "./NotFound.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="home-container">
      <Navbar />

      {/* Centered wrapper */}
      <div className="not-found-container">
        <h1>404</h1>
        <p>{t("notFound.message")}</p>

        {/* Styled button – use Link so it’s still client-side navigation */}
        <Link to="/" className="contact-btn">
          {t("notFound.backToHome")}
          <svg
            className="arrow-icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2L12 22M12 22L5 15M12 22L19 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default NotFound;
